module.exports = __webpack_public_path__ + "static/media/visa.c6b17962.svg";